import React from 'react';
import { createPortal } from 'react-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './services/queryClient';
import ResourceViewer from './components/ResourceViewer';

export default function ReactPortalRoot() {
  // React root lives at #react-portal-root (tiny anchor div).
  // Viewer portals into document.body so it overlays the page at the correct z-level.
  return createPortal(
    <QueryClientProvider client={queryClient}>
      <ResourceViewer />
    </QueryClientProvider>,
    document.body
  );
}
